import { Check } from '@music-vine/cadence/icons';

// Fixed copy, mirrored by Conductor's pop-up preview
const BENEFITS = ['Unlimited premium music, SFX, stock video, motion graphics and LUTs', '100% human-made, no AI', 'Copyright-safe for YouTube & socials'];
export const ReferredVisitorPopupBenefits = () => <ul className="flex flex-col gap-2 rounded-lg bg-gray-100 px-5 py-4 text-left text-sm dark:bg-gray-800" data-sentry-component="ReferredVisitorPopupBenefits" data-sentry-source-file="Benefits.tsx">
    {BENEFITS.map(benefit => <li className="flex gap-2 text-gray-950 dark:text-white" key={benefit}>
        <Check aria-hidden className="mt-0.5 size-4 shrink-0 text-brand-primary" />
        {benefit}
      </li>)}
  </ul>;